<section class="friends-componets content_right">
    <div class="personal_details">
        <div class="col-4 heading-invite-friends">
            <div class="heading-friend">
                <h4>Invite People</h4>
                <!-- <h6 *ngIf="addOrInvite=='invite'" class="invite-link cursor" (click)="addOrInvite='add'">Invite now</h6> -->
            </div>
            <div class="social-links mt-40px pb-55px">
                <div class="social-link-wrap">
                    <ul class="list-style-none">
                        <!-- <li class="cursor" ><img src="assets/copy-link-icon-invite.svg" alt="copy-link-icon"><br>Share Link</li> -->
                        <li class="cursor" (click)="genericSocialShare('whatsapp')"><img
                                src="assets/whatsapp-icon-invite.svg" alt="whatsapp-icon"><br> WhatsApp</li>
                        <!-- <li class="cursor" (click)="genericSocialShare('messenger')"><img src="assets/messenger-icon-invite.svg" alt="messenger"><br> Messenger</li> -->
                        <!-- <li class="cursor" (click)="genericSocialShare('instagram')"><img src="assets/instagram-icon-invite.svg" alt="instagram"><br>Instagram</li> -->
                        <li class="cursor" (click)="genericSocialShare('facebook')"><img
                                src="assets/facebook-icon-invite.svg" alt="facebook"><br>Facebook</li>
                        <li class="cursor" (click)="genericSocialShare('email')"><img src="assets/email-icon-invite.svg"
                                alt="email"><br>Email</li>
                        <li class="cursor" [ngClass]="{'purple-text': copyLinkText =='Link copied'}"
                            (click)="copyLink()"><img [ngClass]="{'purple-text-svg': copyLinkText =='Link copied'}"
                                src="assets/solar_copy-outline.svg" alt=""><br> {{copyLinkText}}</li>

                    </ul>
                </div>
                <!-- <div class="refresh-pause mt-30px">
                    <ul class="list-style-none">
                        <li class="cursor" [ngClass]="{'purple-text': copyLinkText =='Link copied'}" (click)="copyLink()"><img [ngClass]="{'purple-text-svg': copyLinkText =='Link copied'}" src="assets/solar_copy-outline.svg" alt=""><br> {{copyLinkText}}</li>
                        <li class="cursor" [ngClass]="{'purple-text':isRotate}" (click)="regenerateLink()"><img [ngClass]="{'rotate-class':isRotate}"  src="assets/tabler_refresh.svg" alt=""><br> {{refreshLinkText}}</li>
                        <li class="cursor" [ngClass]="{'purple-text':!friendCircleList.invitedIdActivated}" (click)="activeOrPauseLink(friendCircleList.invitedIdActivated?false:true)"><img [ngClass]="{'purple-text-svg':!friendCircleList.invitedIdActivated}" src="assets/mi_pause.svg" alt=""><br> {{pauseText}} </li>
                    </ul>
                </div> -->
            </div>


            <!-- <div class="use-link-to-invite">
                <div class="use-link-to-invite-para">
                    <p>Use your Wondrlink below to invite people</p>
                </div>
                <div class="use-link-to-invite-refresh-pause">
                    <p (click)="regenerateLink()">Refresh</p>
                    <p *ngIf="friendCircleList.invitedIdActivated" (click)="activeOrPauseLink(false)">Pause</p>
                    <p class="purple-text"  *ngIf="!friendCircleList.invitedIdActivated" (click)="activeOrPauseLink(true)">Paused</p>
                </div>
            </div> -->
            <!-- <div class="use-link-to-invite-input-button">
                <input type="text" readonly [placeholder]="referalLink">
                <button (click)="copyLink()">{{copyLinkText}}</button>
            </div> -->
            <!-- <div class="input-add-friend mt-21"  *ngIf="addOrInvite=='add'">
                <input type="text" [(ngModel)]="inviteObj.name" placeholder="Type name...">
                <button [disabled]="!inviteObj.name" (click)="inviteFriend();addOrInvite='invite'">Add Friend</button>
            </div> -->


            <!-- <div class="empty-friend-list-msg" *ngIf="!friendsList?.length && isLoaded">
                <p>Invite your friends to join Wondrfly and build a thriving community together!</p>
            </div> -->
        </div>
        <div class="col-8 invited-friends" *ngIf="rows.length>0">
            <div class="heading-friend">
                <h4>Invited People</h4>
            </div>
            <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" [limit]="10"
                [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">
                <ngx-datatable-column name="Name" prop="name" [width]="150">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                        <div class="d-flex align-items-center">
                            {{row?.name}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Total Fees" prop="net_fees" [width]="40">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                        {{row?.enrolment?.net_fees | currency:'INR':'symbol'}}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Total Paid" prop="total_paid" [width]="40">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                       <span class="badge bg-light-success">{{row?.enrolment?.total_paid | currency:'INR':'symbol'}}</span> 
                    </ng-template>
                </ngx-datatable-column> 
                <ngx-datatable-column name="Pending Amount" prop="pendingAmount" [width]="70">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                        <span class="badge bg-light-danger">{{row?.enrolment?.pendingAmount | currency:'INR':'symbol'}}</span>
                    </ng-template>
                </ngx-datatable-column> 
                <ngx-datatable-column name="Course" prop="course_id">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                        <span class="badge bg-light-danger">{{row?.enrolment?.course_id?.title}}</span>
                    </ng-template>
                </ngx-datatable-column> 
            </ngx-datatable>
        </div>
    </div>



    <!-- <div class="friends-section-line">
    <img src="assets/Line 98.png" alt="">
</div> -->
    <div class="friends-componet mt-40px">


        <div class="friends-list-wrapper">
            <div class="friends-list-row">
                <div class="how-it-work-section">
                    <div class="how-it-work-section-upper-p">
                        <!-- <p>Invite someone. When they join, you both get 3 months of Wondrfly free!</p> -->
                    </div>
                    <div class="how-it-work-heading">
                        <h4 class="text-style">How it works:</h4>
                        <!-- <button [routerLink]="['/parent/referral']" [queryParams]="{ _reflink: referalLink }">Learn
                            More</button> -->
                    </div>
                    <div class="step-box-row">
                        <div class="step-box-info">
                            <h4>Step 1</h4>
                            <h3 class="text-primary">Invite <br> Someone </h3>
                            <div class="step-after-arrow"><img src="assets/step-arrow-icon.svg" /></div>
                        </div>
                        <div class="step-box-info step-after-arror">
                            <h4>Step 2</h4>
                            <h3 class="text-primary">They join Meander Software</h3>
                            <div class="step-after-arrow"><img src="assets/step-arrow-icon.svg" /></div>
                        </div>
                        <!-- <div class="step-box-info bg-step-star">
                            <h4>Step 3</h4>
                            <h3>You both get 3 months</h3>
                        </div> -->
                    </div>
                </div>
            </div>


        </div>

    </div>
</section>

<!------- Popup for Display All Course--------------- -->

<!-- <div>
    <ng-template #modal let-modal>
        <div class="modal-header">
            <h4 class="modal-title">Course</h4>
            <button type="button" class="close" (click)="modal.dismiss()">
                <span>&times;</span>
            </button>
        </div>
        <div class="modal-body">
          {{course_data?.enrolment?.course_id?.title}}
        </div> -->
        <!-- <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="updateReportTo()">Submit</button>
    </div> -->
    <!-- </ng-template>
</div> -->